
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import SessionCounter from '../../Components/SessionCounter'

import SummaryTab from './SummaryTab'
// import MissionsTab from './MissionsTab'
import MineTab from './MineTab'
import MISTab from './MISTab'
import BattlesTab from './BattlesTab'
import SettingsMenuButton from '../../Settings/SettingsMenuButton'
import HelpButton from '../../Settings/HelpButton'

const emptyTab = () => <Tab className="mars--paginator__item" disabled={true}></Tab>
const emptyTabPanel = () => <TabPanel className="disabled" disabled={true}></TabPanel>

class Phase1Screen extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tabIndex: 0,
      activatedTabs: { 0: true, 1: true, 2: false, 3: false, 4: false },
    }
  }

  componentDidMount() {
    const { loadActivity, hideTabs } = this.props
    loadActivity()
    if (hideTabs) {
      //only for tutorial
      const { tab_summary, tab_quarry, tab_mis, tab_battles } = hideTabs
      this.setState({
        tabIndex: [!tab_summary, !tab_quarry, !tab_mis, !tab_battles].indexOf(true),
        activatedTabs: { 0: !tab_summary, 1: !tab_quarry, 2: !tab_mis, 3: !tab_battles },
      })
    }
  }

  nextPhase() {
    const { nextPhase, addHowlSound } = this.props
    addHowlSound('button_click_icon')
    nextPhase()
  }

  stepForward() {
    this.selectTab(this.state.tabIndex + 1)
  }

  stepBack() {
    this.selectTab(this.state.tabIndex - 1)
  }

  selectTab(tabIndex) {
    const { addHowlSound, triggerSelectTab } = this.props
    addHowlSound('button_click_icon')
    triggerSelectTab && triggerSelectTab(tabIndex)
    if (tabIndex >= 0 && tabIndex <= 3) {
      this.setState({
        tabIndex: tabIndex,
        activatedTabs: {
          ...this.state.activatedTabs,
          [tabIndex + 1]: true,
        },
      })
    }
    return true
  }
  renderPaginatorArrow() {
    const { tabIndex } = this.state
    const { hideTabs } = this.props
    let newIndex = tabIndex + 1

    if (hideTabs) {
      //only for tutorial
      const { tab_summary, tab_quarry, tab_mis, tab_battles } = hideTabs
      newIndex = [!tab_summary, !tab_quarry, !tab_mis, !tab_battles].indexOf(true, newIndex)
    }
    return (
      <li onClick={() => this.selectTab(newIndex)} className="mars--paginator__item arrows">
        <span className="icon-point"> </span>
        <span className="icon-point"> </span>
        <span className="icon-point"> </span>
      </li>
    )
  }

  renderFooter() {
    const { hideTabs } = this.props

    const { tab_summary, tab_quarry, tab_mis, tab_battles } = hideTabs || {}

    return (
      <div className="mars--footer">
        <TabList className="mars--paginator">
          {(!tab_summary && (
            <Tab className="mars--paginator__item">
              <FormattedMessage id="phase.tabs.colony" />
            </Tab>
          )) ||
            emptyTab()}

          {(!tab_quarry && (
            <Tab className="mars--paginator__item">
              <FormattedMessage id="phase.tabs.feedback" />
            </Tab>
          )) ||
            emptyTab()}

          {(!tab_mis && (
            <Tab className="mars--paginator__item">
              <FormattedMessage id="phase.tabs.message" />
            </Tab>
          )) ||
            emptyTab()}

          {(!tab_battles && (
            <Tab className="mars--paginator__item">
              <FormattedMessage id="phase.tabs.challenges" />
            </Tab>
          )) ||
            emptyTab()}
        </TabList>
      </div>
    )
  }

  render() {
    const {
      indicators,
      MISInfo,
      currentUser,
      addScreen,
      battlesInfo,
      rivalInfo,
      addHowlSound,
      playersList,
      hideTabs,
    } = this.props

    const { tab_summary, tab_quarry, tab_mis, tab_battles, helpBtn, settingsBtn, sessionCounter } =
      hideTabs || {}

    return (
      <div className="container background background--data">
        <div className="content">
          <div className="mars fase-1">
            {!sessionCounter && <SessionCounter />}
            <div className="mars--header"></div>
            <Tabs
              selectedTabClassName="active"
              disabledTabClassName="disabled"
              selectedIndex={this.state.tabIndex}
              onSelect={(tabIndex) => this.selectTab(tabIndex)}
            >
              {this.renderFooter()}
              {(!tab_summary && (
                <TabPanel>
                  <SummaryTab
                    summary={{
                      ...indicators,
                      federationPosition: currentUser.federation
                        ? currentUser.federation.position
                        : 0,
                      position: currentUser.position,
                      cityLevel: currentUser.cityLevel,
                    }}
                    hideTabs={hideTabs}
                  />
                </TabPanel>
              )) ||
                emptyTabPanel()}
              {(!tab_quarry && (
                <TabPanel>
                  <MineTab user={currentUser} />
                </TabPanel>
              )) ||
                emptyTabPanel()}
              {(!tab_mis && (
                <TabPanel>
                  <MISTab MISInfo={MISInfo} playersList={playersList} />
                </TabPanel>
              )) ||
                emptyTabPanel()}
              {(!tab_battles && (
                <TabPanel>
                  <BattlesTab
                    user={currentUser}
                    rivalInfo={rivalInfo}
                    battlesInfo={battlesInfo}
                    playersList={playersList}
                    startBattle={() => addScreen('start_battle_screen')}
                    onClickNextPhase={() => this.nextPhase()}
                  />
                </TabPanel>
              )) ||
                emptyTabPanel()}
            </Tabs>
            <div className="mars--button__position">
              <div
                onClick={() => {
                  addHowlSound('button_click_icon')
                  this.nextPhase()
                }}
                className="btn--orange"
              >
                <span className="icon-rocket"> </span>
                <span>
                  <FormattedMessage id="phase.goPhase2" />
                </span>
              </div>
            </div>
          </div>
        </div>
        {!helpBtn && <HelpButton />}
        {!settingsBtn && <SettingsMenuButton />}
      </div>
    )
  }
}

Phase1Screen.propTypes = {
  currentUser: PropTypes.object,
  indicators: PropTypes.object,
  MISInfo: PropTypes.array,
  battlesInfo: PropTypes.array,
  rivalInfo: PropTypes.object,
  playersList: PropTypes.object,
  nextPhase: PropTypes.func,
  addScreen: PropTypes.func,
  loadActivity: PropTypes.func,
  addHowlSound: PropTypes.func,
  triggerSelectTab: PropTypes.func,
  hideTabs: PropTypes.object,
}

export default Phase1Screen
